import { faWarning } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { t } from "components/CentralDataMangement/translation/Translation";
import LabelField from "components/common/atoms/LabelField";
import { LabelWithInputField } from "components/common/molecules/LabelWithInputField";
import { WorkingHoursProps } from "components/CompanyCreation/AdminFiche/annotations/AdminFicheInterface";
import React from "react";

interface props {
  shiftTable: WorkingHoursProps;
  handleChange: (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    tableId: number,
    KBId?: number | null
  ) => void;
  tableId: number;
}

const PaidHours: React.FC<props> = ({ shiftTable, handleChange, tableId }) => {
  return (
    <div className="row paidHoursWrapper">
      <div className="col-md-4">
        <LabelWithInputField
          isMandatory={true}
          type="text"
          label={t("Effective hours full-time / week employer")}
          handleChange={(e) => handleChange(e, tableId)}
          value={shiftTable.EffectvHrsFullTime ?? ""}
          name="EffectvHrsFullTime"
          error={shiftTable.EffectvHrsFullTimeError}
        />
      </div>
      <div className="col-md-4">
        <LabelWithInputField
          isMandatory={true}
          type="text"
          label={t("Average hours full-time/week employer")}
          handleChange={(e) => handleChange(e, tableId)}
          value={shiftTable.AvrgHrsFullTime ?? ""}
          name="AvrgHrsFullTime"
          error={shiftTable.AvrgHrsFullTimeError}
        />
      </div>
      <div className="col-md-4">
        <LabelWithInputField
          isMandatory={true}
          type="text"
          label={t("Effective hours/week employee")}
          handleChange={(e) => handleChange(e, tableId)}
          value={shiftTable.EffectvHrs ?? ""}
          name="EffectvHrs"
          error={shiftTable.EffectvHrsError}
        />
      </div>
      <div className="col-md-4 advPerWeek">
        <LabelWithInputField
          type="text"
          label={t("Total ADV hours per week")}
          value={shiftTable.calculatedADV ?? ""}
          name="calculatedADV"
          isDisabled={true}
        />
      </div>
      <div className="col-md-4 advPerWeek">
        <LabelWithInputField
          isMandatory={true}
          type="text"
          label={t("Paid ADV hours per week")}
          handleChange={(e) => handleChange(e, tableId)}
          value={shiftTable.paidADV ?? ""}
          name="paidADV"
          error={shiftTable.paidADVError}
        />
      </div>
      <div className="col-md-4 advPerWeek">
        <LabelWithInputField
          isMandatory={true}
          type="text"
          label={t("Unpaid ADV hours per week")}
          handleChange={(e) => handleChange(e, tableId)}
          value={shiftTable.unPaidADV ?? ""}
          name="unPaidADV"
          error={shiftTable.unPaidADVError}
        />
      </div>
      {shiftTable?.advStatusError !== '' && (
      <div className="col-12">
        <div className="marginBotttom1 danger-message">
          <span className="marginRightPoint5">
            <FontAwesomeIcon icon={faWarning} />
          </span>
          {shiftTable.advStatusError ?? ''}
        </div>
      </div>
      )}
      <LabelField
        title={t("Overtime")}
        className="tab-subtitle pb-0 marginBottomPoint5"
        isMandatory={true}
      />
      <div className="col-4">
        <div className="input-group adminFicheSuffixTextOvertime adminFicheSuffixTextOvertimeLabel position-relative">
          <LabelWithInputField
            type="text"
            label=""
            handleChange={(e) => handleChange(e, tableId)}
            value={shiftTable.overtimeDay ?? ""}
            name="overtimeDay"
            error={shiftTable.overtimeDayError}
          />
          <span
            className="input-group-text rounded-start-0 rounded-end-3 border-0 position-absolute"
            id="basic-addon1"
          >
            {t(" hours/day at 100%")}
          </span>
        </div>
      </div>
      <div className="col-4">
        <div className="input-group adminFicheSuffixTextOvertime adminFicheSuffixTextOvertimeLabel position-relative">
          <LabelWithInputField
            type="text"
            label=""
            handleChange={(e) => handleChange(e, tableId)}
            value={shiftTable.overtimeWeek ?? ""}
            name="overtimeWeek"
            error={shiftTable.overtimeWeekError}
          />
          <span
            className="input-group-text rounded-start-0 rounded-end-3 border-0 position-absolute"
            id="basic-addon1"
          >
            {t(" hours/week at 100%")}
          </span>
        </div>
      </div>
    </div>
  );
};

export default React.memo(PaidHours);
